import * as React from 'react';
import { C as Context } from './injectIntl-68401e69-320564cc.js';
import { i as invariantIntlContext } from '../utils-4a8b3c7d-cdea6863.js';

function useIntl() {
  var intl = React.useContext(Context);
  invariantIntlContext(intl);
  return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-8b5154d9-98867d9c.js.map
